(function() {
  'use strict';

  // Native fetch speichern bevor Shopify ihn überschreibt
  const nativeFetch = window.fetch.bind(window);

  const appEl = document.getElementById('schnellbestellung-app');
  if (!appEl) return;

  const CONFIG = {
    apiUrl: appEl.dataset.apiUrl || '',
    apiSecret: appEl.dataset.apiSecret || '',
  };

  let CATALOG = {};
  let items = [];
  let parsedHeaders = [];
  let parsedRows = [];
  let extractedItems = [];
  let currentFilename = '';

  // ============================================================
  // INIT
  // ============================================================
  async function init() {
    showSection('sb-upload');
    await loadCatalog();
    bindEvents();
  }

  async function loadCatalog() {
    try {
      const res = await nativeFetch(`${CONFIG.apiUrl}/api/catalog`);
      const data = await res.json();
      const rules = data.quantityRules || {};
      for (const [sku, p] of Object.entries(rules)) {
        CATALOG[sku] = {
          name: p.name || sku,
          vendor: p.vendor || '',
          variantId: p.variantId || null,
          available: p.available !== false,
          qr: p.qr || null
        };
      }
      const el = document.getElementById('catalog-info');
      if (el) el.textContent = Object.keys(CATALOG).length + ' Produkte geladen';
    } catch (err) {
      showError('Katalog konnte nicht geladen werden.');
    }
  }

  // ============================================================
  // QUANTITY RULE
  // ============================================================
  function adjustQty(qty, sku) {
    const rule = CATALOG[sku]?.qr;
    if (!rule) return qty;
    let q = Math.max(qty, rule.min || 1);
    const inc = rule.inc || 1;
    if (inc > 1) {
      const r = q % inc;
      if (r !== 0) q = q + (inc - r);
    }
    if (rule.max && q > rule.max) q = rule.max;
    return q;
  }

  function vpeLabel(sku) {
    const rule = CATALOG[sku]?.qr;
    if (!rule || !rule.inc || rule.inc <= 1) return '';
    return `<div style="font-size:11px;color:#b45309;background:#fef3c7;padding:2px 6px;border-radius:4px;margin-top:3px;display:inline-block">VPE ${rule.inc} Stück</div>`;
  }

  // ============================================================
  // MODUS 1: CSV/XLSX MIT SKUs
  // ============================================================
  function handleCSVFile(file) {
    currentFilename = file.name;
    const ext = file.name.split('.').pop().toLowerCase();
    const reader = new FileReader();
    if (ext === 'csv') {
      reader.onload = e => parseCSV(e.target.result);
      reader.readAsText(file);
    } else {
      reader.onload = e => parseXLSX(e.target.result);
      reader.readAsArrayBuffer(file);
    }
  }

  function parseCSV(text) {
    const sep = text.includes(';') ? ';' : (text.includes('\t') ? '\t' : ',');
    const lines = text.trim().split('\n').map(l => l.split(sep).map(c => c.trim().replace(/^["']|["']$/g, '')));
    if (lines.length < 2) { showError('Keine Daten.'); return; }
    parsedHeaders = lines[0];
    parsedRows = lines.slice(1).filter(r => r.some(c => c.trim()));
    showMapping();
  }

  function parseXLSX(buf) {
    const wb = XLSX.read(buf, { type: 'array' });
    const aoa = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1, defval: '' });
    if (aoa.length < 2) { showError('Keine Daten.'); return; }
    parsedHeaders = aoa[0].map(h => String(h));
    parsedRows = aoa.slice(1).filter(r => r.some(c => String(c).trim()));
    showMapping();
  }

  function showMapping() {
    showSection('sb-mapping');
    const skuSel = document.getElementById('sku-col-select');
    const qtySel = document.getElementById('qty-col-select');
    const filenameEl = document.getElementById('mapping-filename');
    const rowCount = document.getElementById('row-count');

    if (filenameEl) filenameEl.textContent = currentFilename;
    if (rowCount) rowCount.textContent = parsedRows.length + ' Zeilen';

    // Auto-detect SKU und Menge
    const skuIdx = parsedHeaders.findIndex(h => /sku|artikel|art\.?nr|item|nummer/i.test(h));
    const qtyIdx = parsedHeaders.findIndex(h => /qty|menge|anzahl|quantity|stück/i.test(h));

    [skuSel, qtySel].forEach((sel, i) => {
      if (!sel) return;
      sel.innerHTML = i === 0 ? '' : '<option value="-1">Keine / Menge 1</option>';
      parsedHeaders.forEach((h, idx) => {
        const opt = document.createElement('option');
        opt.value = idx;
        opt.textContent = h || ('Spalte ' + (idx + 1));
        sel.appendChild(opt);
      });
    });

    if (skuSel && skuIdx >= 0) skuSel.value = skuIdx;
    if (qtySel && qtyIdx >= 0) qtySel.value = qtyIdx;

    // Vorschau: nur Artikelnummer, Bezeichnung, Menge
    const preview = document.getElementById('preview-table');
    if (preview) {
      const skuI = skuIdx >= 0 ? skuIdx : 0;
      const qtyI = qtyIdx >= 0 ? qtyIdx : -1;
      const nameI = parsedHeaders.findIndex((h, i) => i !== skuI && i !== qtyI && !/gewicht|weight|vpe|ean|gtin|preis|price/i.test(h));
      const cols = [skuI, nameI >= 0 ? nameI : -1, qtyI].filter(i => i >= 0);
      const colNames = cols.map(i => parsedHeaders[i]);

      preview.innerHTML = '<thead><tr>' + colNames.map(h => `<th>${h}</th>`).join('') + '</tr></thead>' +
        '<tbody>' + parsedRows.map(r =>
          '<tr>' + cols.map(i => `<td>${r[i] !== undefined ? r[i] : ''}</td>`).join('') + '</tr>'
        ).join('') + '</tbody>';

      const info = document.getElementById('preview-info');
      if (info) info.textContent = parsedRows.length + ' Zeilen';
    }
  }

  async function processCSV(skuIdx, qtyIdx) {
    // Katalog nachladen falls noch leer
    if (Object.keys(CATALOG).length === 0) {
      const el = document.getElementById('catalog-info');
      if (el) el.textContent = 'Katalog wird geladen...';
      await loadCatalog();
    }

    const found = [];
    const notFound = [];

    for (const row of parsedRows) {
      const sku = String(row[skuIdx] || '').trim();
      if (!sku) continue;
      const rawQty = qtyIdx >= 0 ? (parseInt(row[qtyIdx]) || 1) : 1;
      if (CATALOG[sku]) {
        const qty = adjustQty(rawQty, sku);
        found.push({ sku, qty, originalQty: rawQty, name: CATALOG[sku].name, vendor: CATALOG[sku].vendor, qr: CATALOG[sku].qr });
      } else {
        // Produktname aus CSV-Zeile holen für "Nicht gefunden" Anzeige
        const nameIdx = parsedHeaders.findIndex((h, i) => i !== skuIdx && /bezeichnung|name|produkt|artikel/i.test(h));
        const csvRow = parsedRows.find(r => String(r[skuIdx]).trim() === sku);
        const rawName = (nameIdx >= 0 && csvRow) ? String(csvRow[nameIdx] || '').trim() : '';
        notFound.push({ sku, qty: rawQty, name: rawName });
      }
    }

    if (!found.length && !notFound.length) { showError('Keine Daten gefunden.'); return; }

    items = found;
    renderResults(notFound);
  }

  // ============================================================
  // MODUS 2: PDF
  // ============================================================
  async function handlePDFFile(file) {
    if (!file.name.toLowerCase().endsWith('.pdf')) { showError('Bitte PDF hochladen.'); return; }
    currentFilename = file.name;
    showSection('sb-processing');
    setStep('read');

    try {
      const base64 = await toBase64(file);
      setStep('extract');

      const catalogSkus = {};
      for (const [sku, p] of Object.entries(CATALOG)) catalogSkus[sku] = p.name;

      const res = await nativeFetch(`${CONFIG.apiUrl}/api/smart-match`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-API-Secret': CONFIG.apiSecret },
        body: JSON.stringify({ pdf_base64: base64, catalog_skus: catalogSkus })
      });

      const data = await res.json();
      if (!data.success) throw new Error(data.error);
      setStep('match');

      extractedItems = data.items.map(item => {
        const cat = item.matched_sku ? CATALOG[item.matched_sku] : null;
        const adjQty = cat ? adjustQty(item.pdf_quantity, item.matched_sku) : item.pdf_quantity;
        return {
          pdfName: item.pdf_product_name,
          pdfArticle: item.pdf_article_number || '',
          pdfQty: item.pdf_quantity,
          adjQty,
          sku: item.matched_sku || null,
          name: cat?.name || null,
          vendor: cat?.vendor || '',
          confidence: item.match_confidence || 'none',
          qr: cat?.qr || null,
          include: item.match_confidence !== 'none' && item.match_confidence !== 'low' && !!cat
        };
      });

      renderExtract();
    } catch (err) {
      showSection('sb-upload');
      showError('PDF Fehler: ' + err.message);
    }
  }

  // ============================================================
  // MODUS 3: OHNE SKUs (KI)
  // ============================================================
  async function handleSmartFile(file) {
    currentFilename = file.name;
    showSection('sb-processing');
    setStep('read');

    try {
      const products = await extractProductsFromFile(file);
      if (!products.length) { showSection('sb-upload'); showError('Keine Produkte gefunden.'); return; }
      setStep('extract');

      const catalogSkus = {};
      for (const [sku, p] of Object.entries(CATALOG)) catalogSkus[sku] = p.name;

      const res = await nativeFetch(`${CONFIG.apiUrl}/api/smart-match`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-API-Secret': CONFIG.apiSecret },
        body: JSON.stringify({ product_list: products, catalog_skus: catalogSkus })
      });

      const data = await res.json();
      if (!data.success) throw new Error(data.error);
      setStep('match');

      extractedItems = data.items.map(item => {
        const cat = item.matched_sku ? CATALOG[item.matched_sku] : null;
        const adjQty = cat ? adjustQty(item.pdf_quantity, item.matched_sku) : item.pdf_quantity;
        return {
          pdfName: item.pdf_product_name,
          pdfArticle: item.pdf_article_number || '',
          pdfQty: item.pdf_quantity,
          adjQty,
          sku: item.matched_sku || null,
          name: cat?.name || null,
          vendor: cat?.vendor || '',
          confidence: item.match_confidence || 'none',
          qr: cat?.qr || null,
          include: item.match_confidence !== 'none' && item.match_confidence !== 'low' && !!cat
        };
      });

      renderExtract();
    } catch (err) {
      showSection('sb-upload');
      showError('KI Fehler: ' + err.message);
    }
  }

  async function extractProductsFromFile(file) {
    const ext = file.name.split('.').pop().toLowerCase();
    const products = [];
    if (ext === 'csv') {
      const text = await file.text();
      const sep = text.includes(';') ? ';' : (text.includes('\t') ? '\t' : ',');
      const lines = text.trim().split('\n').map(l => l.split(sep).map(c => c.trim().replace(/^["']|["']$/g, '')));
      const header = lines[0];
      const nameI = header.findIndex(h => /name|bezeichnung|produkt|artikel|item/i.test(h));
      const qtyI = header.findIndex(h => /menge|qty|anzahl|quantity/i.test(h));
      for (const row of lines.slice(1)) {
        const name = row[nameI >= 0 ? nameI : 1] || '';
        const qty = parseInt(row[qtyI >= 0 ? qtyI : 2]) || 1;
        if (name.length > 2) products.push({ name, qty });
      }
    } else {
      const buf = await file.arrayBuffer();
      const wb = XLSX.read(buf, { type: 'array' });
      for (const sheet of wb.SheetNames) {
        const aoa = XLSX.utils.sheet_to_json(wb.Sheets[sheet], { header: 1, defval: '' });
        for (const row of aoa) {
          let name = '', qty = 0, sku = '';
          for (const cell of row.map(c => String(c).trim())) {
            if (!cell || cell === 'NaN') continue;
            if (/^\d{5,8}$/.test(cell) || /^[A-Z0-9]+-[A-Z0-9]+/i.test(cell)) { if (!sku) sku = cell; }
            else if (/^\d+$/.test(cell) && !qty) qty = parseInt(cell);
            else if (cell.length > 5 && cell.length > name.length && !/^(Pos|Nr|Menge|Qty|Bezeichnung|Art\.|K2|VPE)/i.test(cell)) name = cell;
          }
          if (name && qty > 0) products.push({ name, qty, sku: sku || undefined });
        }
      }
    }
    return products;
  }

  // ============================================================
  // RENDER: EXTRACT (PDF / KI)
  // ============================================================
  function renderExtract() {
    showSection('sb-extract');
    const tbody = document.getElementById('sb-extract-body');
    if (!tbody) return;

    const matched = extractedItems.filter(i => i.sku && i.include).length;
    const total = extractedItems.length;
    const matchedEl = document.getElementById('sb-extract-matched');
    const skippedEl = document.getElementById('sb-extract-skipped');
    const countEl = document.getElementById('sb-extract-count');
    if (matchedEl) matchedEl.textContent = matched + ' gefunden';
    if (skippedEl) skippedEl.textContent = (total - matched) + ' nicht gefunden';
    if (countEl) countEl.textContent = total + ' Positionen';

    tbody.innerHTML = extractedItems.map((item, idx) => {
      const hasMatch = item.sku && item.name;
      const confColor = item.confidence === 'high' ? '#15803d' : item.confidence === 'medium' ? '#b45309' : item.confidence === 'low' ? '#7c3aed' : '#dc2626';
      const confLabel = item.confidence === 'high' ? 'Sicher' : item.confidence === 'medium' ? 'Wahrscheinlich' : item.confidence === 'low' ? 'Möglich' : 'Kein Match';
      const rounded = item.adjQty !== item.pdfQty ? `<div style="font-size:11px;color:#b45309;margin-top:2px">↑ aufgerundet von ${item.pdfQty}</div>` : '';

      return `<tr style="${hasMatch ? '' : 'opacity:0.45'}">
        <td>
          <div style="font-size:13px;font-weight:500">${item.pdfName}</div>
          ${item.pdfArticle ? `<div style="font-size:11px;color:#6b7280">Art.Nr.: ${item.pdfArticle}</div>` : ''}
        </td>
        <td>
          ${hasMatch
            ? `<div style="font-size:13px;font-weight:500">${item.name}</div><div style="font-size:11px;color:${confColor}">${confLabel}</div>`
            : `<span style="font-size:12px;color:#9ca3af">Nicht gefunden</span>`}
        </td>
        <td style="font-size:11px;color:#6b7280;font-family:monospace">${item.sku || ''}</td>
        <td style="text-align:center">
          ${hasMatch
            ? `<div style="display:flex;align-items:center;justify-content:center;gap:4px">
                <button onclick="window._extQty(${idx},-1)" style="width:22px;height:22px;border:1px solid #d1d5db;border-radius:4px;background:#fff;cursor:pointer">-</button>
                <span style="min-width:28px;text-align:center;font-weight:600;font-size:13px">${item.adjQty}</span>
                <button onclick="window._extQty(${idx},1)" style="width:22px;height:22px;border:1px solid #d1d5db;border-radius:4px;background:#fff;cursor:pointer">+</button>
               </div>${rounded}${vpeLabel(item.sku)}`
            : `<span style="font-size:13px">${item.pdfQty}</span>`}
        </td>
        <td style="text-align:center">
          ${hasMatch ? `<input type="checkbox" ${item.include ? 'checked' : ''} onchange="window._extToggle(${idx})" style="cursor:pointer">` : ''}
        </td>
      </tr>`;
    }).join('');

    window._extQty = (idx, delta) => {
      const item = extractedItems[idx];
      const inc = item.qr?.inc || 1;
      let q = item.adjQty + delta * inc;
      const min = item.qr?.min || inc;
      if (q < min) q = min;
      if (item.qr?.max && q > item.qr.max) q = item.qr.max;
      item.adjQty = q;
      renderExtract();
    };

    window._extToggle = (idx) => { extractedItems[idx].include = !extractedItems[idx].include; };
  }

  // ============================================================
  // RENDER: RESULTS (Bestellübersicht)
  // ============================================================
  function renderResults(notFound) {
    showSection('sb-results');
    const tbody = document.getElementById('sb-results-body');
    const countEl = document.getElementById('sb-item-count');
    if (!tbody) return;

    tbody.innerHTML = items.map((item, idx) => {
      const rounded = item.originalQty && item.originalQty !== item.qty
        ? `<div style="font-size:11px;color:#b45309;margin-top:2px">↑ von ${item.originalQty}</div>` : '';
      return `<tr>
        <td><input type="checkbox" checked onchange="window._resToggle(${idx})" style="cursor:pointer"></td>
        <td style="font-size:11px;color:#6b7280;font-family:monospace">${item.sku}</td>
        <td>
          <div style="font-weight:500;font-size:13px">${item.name}</div>
          <div style="font-size:11px;color:#6b7280">${item.vendor}</div>
        </td>
        <td style="text-align:center">
          <div style="display:flex;align-items:center;justify-content:center;gap:4px">
            <button onclick="window._resQty(${idx},-1)" style="width:22px;height:22px;border:1px solid #d1d5db;border-radius:4px;background:#fff;cursor:pointer">-</button>
            <span style="min-width:28px;text-align:center;font-weight:600;font-size:13px">${item.qty}</span>
            <button onclick="window._resQty(${idx},1)" style="width:22px;height:22px;border:1px solid #d1d5db;border-radius:4px;background:#fff;cursor:pointer">+</button>
          </div>
          ${rounded}${vpeLabel(item.sku)}
        </td>
        <td style="text-align:center">
          <button onclick="window._resRemove(${idx})" style="background:none;border:none;cursor:pointer;color:#9ca3af;font-size:16px">✕</button>
        </td>
      </tr>`;
    }).join('');

    // Nicht gefundene SKUs grau anzeigen
    if (notFound && notFound.length) {
      tbody.innerHTML += notFound.map(item => `
        <tr style="opacity:0.4">
          <td></td>
          <td style="font-size:11px;color:#6b7280;font-family:monospace">${item.sku}</td>
          <td>
            <div style="font-size:13px;font-weight:500;color:#6b7280">${item.name || ''}</div>
            <div style="font-size:11px;color:#9ca3af">Nicht gefunden</div>
          </td>
          <td style="text-align:center;font-size:13px;color:#6b7280">${item.qty}</td>
          <td></td>
        </tr>`).join('');
    }

    if (countEl) countEl.textContent = items.length + ' Produkte' + (notFound?.length ? `, ${notFound.length} nicht gefunden` : '');

    window._resQty = (idx, delta) => {
      const item = items[idx];
      const inc = item.qr?.inc || 1;
      let q = item.qty + delta * inc;
      const min = item.qr?.min || inc;
      if (q < min) q = min;
      if (item.qr?.max && q > item.qr.max) q = item.qr.max;
      items[idx].qty = q;
      renderResults();
    };

    window._resRemove = (idx) => {
      items.splice(idx, 1);
      if (!items.length) { showSection('sb-upload'); return; }
      renderResults();
    };

    window._resToggle = (idx) => { /* checkbox visual only */ };
  }

  function confirmExtract() {
    items = extractedItems
      .filter(i => i.include && i.sku && CATALOG[i.sku])
      .map(i => ({ sku: i.sku, qty: i.adjQty, originalQty: i.pdfQty, name: i.name, vendor: i.vendor, qr: i.qr }));
    if (!items.length) { showError('Keine Produkte ausgewählt.'); return; }
    renderResults();
  }

  // ============================================================
  // WARENKORB
  // ============================================================
  async function addToCart() {
    const cartItems = items
      .filter(i => CATALOG[i.sku]?.variantId)
      .map(i => ({ id: parseInt(CATALOG[i.sku].variantId), quantity: i.qty }));

    if (!cartItems.length) { showError('Keine Produkte für den Warenkorb.'); return; }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    });

    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.description || 'Warenkorb Fehler');
    }
    return res.json();
  }

  // ============================================================
  // HELPERS
  // ============================================================
  function toBase64(file) {
    return new Promise((res, rej) => {
      const r = new FileReader();
      r.onload = () => res(r.result.split(',')[1]);
      r.onerror = () => rej(new Error('Lesefehler'));
      r.readAsDataURL(file);
    });
  }

  function showError(msg) {
    const el = document.getElementById('sb-error');
    if (el) { el.textContent = msg; el.style.display = 'block'; setTimeout(() => el.style.display = 'none', 8000); }
  }

  function showSection(id) {
    ['sb-upload', 'sb-mapping', 'sb-processing', 'sb-extract', 'sb-results', 'sb-success']
      .forEach(s => { const el = document.getElementById(s); if (el) el.style.display = s === id ? 'block' : 'none'; });
  }

  function setStep(step) {
    const steps = ['read', 'extract', 'match'];
    steps.forEach((s, i) => {
      const el = document.getElementById('step-' + s);
      if (!el) return;
      const idx = steps.indexOf(step);
      el.className = 'sb-step' + (i < idx ? ' done' : i === idx ? ' active' : '');
    });
  }

  function reset() {
    items = []; parsedHeaders = []; parsedRows = []; extractedItems = [];
    showSection('sb-upload');
  }

  function bindUploadZone(zoneId, inputId, handler) {
    const zone = document.getElementById(zoneId);
    const input = document.getElementById(inputId);
    if (!zone || !input) return;
    zone.addEventListener('dragover', e => { e.preventDefault(); zone.classList.add('dragover'); });
    zone.addEventListener('dragleave', () => zone.classList.remove('dragover'));
    zone.addEventListener('drop', e => { e.preventDefault(); zone.classList.remove('dragover'); if (e.dataTransfer.files[0]) handler(e.dataTransfer.files[0]); });
    input.addEventListener('change', e => { if (e.target.files[0]) handler(e.target.files[0]); });
    zone.addEventListener('click', e => { if (e.target !== input) input.click(); });
  }

  // ============================================================
  // EVENTS
  // ============================================================
  function bindEvents() {
    // Tabs
    document.querySelectorAll('[data-tab]').forEach(tab => {
      tab.addEventListener('click', () => {
        document.querySelectorAll('[data-tab]').forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        document.querySelectorAll('[data-tab-content]').forEach(c => c.style.display = 'none');
        const target = document.getElementById('tab-' + tab.dataset.tab);
        if (target) target.style.display = 'block';
      });
    });

    bindUploadZone('dropzone-csv', 'file-input-csv', handleCSVFile);
    bindUploadZone('dropzone-smart', 'file-input-smart', handleSmartFile);
    bindUploadZone('dropzone-pdf', 'file-input-pdf', handlePDFFile);

    // Mapping confirm
    const mapBtn = document.getElementById('mapping-confirm-btn');
    if (mapBtn) mapBtn.addEventListener('click', async () => {
      const si = parseInt(document.getElementById('sku-col-select')?.value);
      const qi = parseInt(document.getElementById('qty-col-select')?.value);
      if (isNaN(si) || si < 0) { showError('SKU Spalte wählen.'); return; }
      mapBtn.disabled = true;
      mapBtn.textContent = 'Wird verarbeitet...';
      await processCSV(si, qi);
      mapBtn.disabled = false;
      mapBtn.textContent = 'Übernehmen';
    });

    // Extract confirm
    const extBtn = document.getElementById('extract-confirm-btn');
    if (extBtn) extBtn.addEventListener('click', confirmExtract);

    // Cart
    const cartBtn = document.getElementById('sb-cart-btn');
    if (cartBtn) cartBtn.addEventListener('click', async () => {
      try {
        cartBtn.disabled = true;
        cartBtn.textContent = 'Wird hinzugefügt...';
        await addToCart();
        showSection('sb-success');
        const tq = items.reduce((s, i) => s + i.qty, 0);
        const titleEl = document.getElementById('sb-success-title');
        const subEl = document.getElementById('sb-success-sub');
        if (titleEl) titleEl.textContent = tq + ' Artikel in den Warenkorb gelegt';
        if (subEl) subEl.textContent = items.length + ' Produkte wurden hinzugefügt';
      } catch (err) {
        showError('Warenkorb Fehler: ' + err.message);
        cartBtn.disabled = false;
        cartBtn.textContent = 'In den Warenkorb';
      }
    });

    // Template download
    const tmpl = document.getElementById('download-template');
    if (tmpl) tmpl.addEventListener('click', () => {
      const csv = 'SKU;Menge\n701545;10\n705100-3300;24\n';
      const blob = new Blob([csv], { type: 'text/csv' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'solarvie-bestellung-vorlage.csv';
      a.click();
    });

    document.querySelectorAll('[data-action="reset"]').forEach(btn => btn.addEventListener('click', reset));
    document.querySelectorAll('[data-action="back"]').forEach(btn => btn.addEventListener('click', () => showSection('sb-upload')));
  }

  document.addEventListener('DOMContentLoaded', init);
})();